import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { Link, useNavigate } from 'react-router-dom';
import { Award, BookOpen, CheckCircle, Clock, DollarSign, Download, Heart, Info, LogIn, LogOut, MessageSquare, Moon, PieChart, Settings, Star, Sun, User, Users } from 'react-feather';
import { User as UserType } from '../../types';
import { Gamepad2, LayoutGrid, Clipboard, Megaphone } from 'lucide-react';
import { isIOSWebView } from '../../utils/platform';
import { useAuth } from '../../contexts/auth-context';
import { useTheme } from '../../contexts/theme-context';
import { Icon } from '../icon';
import Cookies from 'js-cookie';
import { t } from '../../i18nTranslate';

interface NavbarRightProps {
    title?: string;
    children: React.ReactNode;
    closeRef?: React.RefObject<any | null | undefined>;
}

const NavbarRight: React.FC<NavbarRightProps> = ({ title, children, closeRef }) => {
    const { isAuthenticated, user, fetchUser } = useAuth();
    const { isDarkMode, toggleDarkMode } = useTheme(); // Certifique-se de que isso está dentro de um componente que é filho de ThemeProvider
    // const closeRef = useRef<HTMLButtonElement | null>(null);
    const [usersSessions, setUsersSessions] = useState<UserType[]>([]);
    const { changeUser, logout, isSuper } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const users = JSON.parse(Cookies.get('saved_users') ?? "[]");
        setUsersSessions(users); // Remove o return, pois `setState` não pode ser retornado
    }, []);


    function handleLogout() {
        if (closeRef && closeRef.current)
            closeRef.current.click()
        logout(true);
    }

    return (
        <>
            <div className="offcanvas offcanvas-end" data-bs-scroll="true" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
                {!!title && (
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="offcanvasWithBothOptionsLabel">{title}</h5>
                        {closeRef && closeRef != undefined ? (
                            <button ref={closeRef} type="button" className="btn-close btn-dark" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        ) : null}
                    </div>
                )}
                {closeRef && closeRef != undefined ? (
                    <button ref={closeRef} type="button" className="btn-close btn-dark d-none" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                ) : null}

                <div className="user-select-none offcanvas-body" style={{overflowX: "hidden" }}>
                    {children}

                    <span onClick={toggleDarkMode} id="container-menu-right-item" className="container-menu-right-item cursor-pointer link-menu-right d-flex">
                        {!isDarkMode ? (
                            <>
                                <Icon invertColor={!isDarkMode} className='menu-father-icon' size={30} name="sunny">
                                    <Moon className='menu-father-icon'size={30} opacity={.7}/> 
                                </Icon> {t("settings.dark")}
                            </>
                        ) : (
                            <>
                                <Icon invertColor={!isDarkMode} className='menu-father-icon' size={30} name="bedtime">
                                    <Sun  className='menu-father-icon' size={30} opacity={.7}/> 
                                </Icon> {t("settings.light")}
                            </>
                        )}
                    </span>

                    {!isAuthenticated ? (
                        <>
                            <Link className="container-menu-right-item link-menu-right color-red" to="/login">
                                <LogIn className='menu-father-icon' data-feather="log-in" size={30} opacity={.7}/>
                                {t('generics.login')}
                            </Link>
                        </>

                    ) : (
                        <>
                            <span className="container-menu-right-item cursor-pointer user-select-none link-menu-right text-red" onClick={handleLogout}>
                                <LogOut className="menu-father-icon" data-feather="log-out" size={30} opacity={.7}/> {t('generics.logout')}
                            </span>
                        </>
                    )}

                </div>
            </div>
        </>
    );
};

export default NavbarRight;
